// extracted by mini-css-extract-plugin
module.exports = {"root":"Swiper_root__8_KJV"};